import type {
  EntityObject, EnvironmentLookupFn, OverreactSpec, RequestVariables, SideEffectFn, SpecType,
} from '../public-types';
import type { RequestContract } from './request-contract';
import type { ResponseContract } from './response-contract';

export function createSpec<
  TVariables extends object = RequestVariables,
  TData = unknown,
  TEntity extends EntityObject = EntityObject,
  TResult extends TEntity | TEntity[] | null = TEntity,
  TNetworkResponse = unknown,
>(
  requestContract: RequestContract<TVariables, TData>,
  responseContract: ResponseContract<TVariables, TData, TEntity, TNetworkResponse, TResult>,
  specType: SpecType,
  sideEffectFn?: SideEffectFn<TVariables, TData, TResult, TEntity> | null,
  environmentLookupFn?: EnvironmentLookupFn,
): OverreactSpec<TVariables, TData, TResult, TEntity> {
  return {
    requestContract,
    responseContract,
    specType,
    sideEffectFn,
    environmentLookupFn,
  };
}
